import { FileUploadAPI } from "api";
import ActionButton from "components/common/ActionButton";
import FalconLightBox from "components/common/FalconLightBox";
import Flex from "components/common/Flex";
import React, { useState } from "react";
import { Button, Col, Form, Image, Row, Table } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FaImage } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const VisitLabReports = () => {
  const {
    register,
    watch,
    control,
    setValue,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const {
    fields: labTests,
    append: appendLabTests,
    remove: removeLabTests,
  } = useFieldArray({
    control,
    name: "labTests",
  });

  const navigate = useNavigate();
  const { state } = useLocation();

  const [previewUrl, setPreviewUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [fileUrl, setFileUrl] = useState("");
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState(null);

  const [uploadedFiles, setUploadedFiles] = useState({});

  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: {
      "image/*": [".jpeg", ".png", ".jpg"],
    },

    onDrop: (files, index) => handleDrop(files, index),

    // onDrop: async (acceptedFiles) => {
    //   const uploadedFile = acceptedFiles[0];
    //   const uploadedFileUrl = await uploadFile(uploadedFile);
    //   setFileUrl(uploadedFileUrl);
    //   setFile(
    //     Object.assign(uploadedFile, {
    //       preview: URL.createObjectURL(uploadedFile),
    //     })
    //   );
    // },
  });

  const handleDrop = async (acceptedFiles, index) => {
    const file = acceptedFiles[0];
    const url = await uploadFile(file);

    if (!url) {
      toast.error("Upload failed");
      return;
    }

    const previewUrl = URL.createObjectURL(file);

    const newFile = {
      name: file.name,
      preview: previewUrl,
      url,
    };

    setUploadedFiles((prev) => ({
      ...prev,
      [index]: newFile,
    }));

    setValue(`labTests[${index}].fileName`, file.name);
    setValue(`labTests[${index}].filePath`, url);
  };

  // console.log("uploadedFiles", uploadedFiles);

  const uploadFile = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      setLoading(true);
      const response = await FileUploadAPI.post(formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setLoading(false);

      // console.log(response.data);

      // Assuming the response contains the URL of the uploaded file
      return response?.data?.data;
    } catch (error) {
      console.error("File upload failed:", error);
      toast.error("File upload failed");
      return "";
    }
  };

  return (
    <>
      <Row className="gx-2 mt-3">
        <div
          style={{
            maxHeight: `calc(100vh - 20.7rem)`,
            overflowY: "auto",
          }}
        >
          <Table style={{ borderCollapse: "separate", borderSpacing: 0 }}>
            {/* 🔹 Fixed Header */}
            <thead
              className="bg-200"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                background: "#fff",
              }}
            >
              <tr>
                <th
                  scope="col"
                  className="fs-10 text-center"
                  // style={{ width: "140px" }}
                >
                  #
                </th>
                <th scope="col" className="fs-10">
                  Test Name
                </th>
                <th scope="col" className="fs-10">
                  Test Date
                </th>
                <th scope="col" className="fs-10">
                  Results
                </th>
                <th scope="col" className="fs-10">
                  Normal Range
                </th>
                <th scope="col" className="fs-10">
                  Notes
                </th>
                <th scope="col" className="fs-10">
                  File
                </th>
                <th scope="col" className="fs-10"></th>
                <th
                  scope="col"
                  style={{ padding: "9px", width: "10px" }}
                  className="text-end"
                >
                  <ActionButton
                    icon="plus"
                    variant="success"
                    title="Add"
                    className="px-1 py-0"
                    onClick={() => appendLabTests({})}
                  />
                </th>
              </tr>
            </thead>

            {/* 🔹 Table Body */}
            <tbody>
              {labTests.map((item, index) => (
                <tr key={item.id || index}>
                  <td className="text-center">{index + 1}</td>
                  <td style={{ padding: "10px" }}>
                    <Form.Control
                      type="text"
                      placeholder="Test Name"
                      tabIndex={5}
                      isInvalid={!!errors.labTests?.[index]?.testName}
                      {...register(`labTests[${index}].testName`)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.labTests?.[index]?.testName?.message}
                    </Form.Control.Feedback>
                  </td>

                  <td style={{ paddingTop: "10px" }}>
                    <Form.Control
                      type="date"
                      placeholder="Test Date"
                      tabIndex={5}
                      isInvalid={!!errors.labTests?.[index]?.testDate}
                      {...register(`labTests[${index}].testDate`)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.labTests?.[index]?.testDate?.message}
                    </Form.Control.Feedback>
                  </td>
                  <td style={{ paddingTop: "10px" }}>
                    <Form.Control
                      type="text"
                      placeholder="Results"
                      isInvalid={!!errors.labTests?.[index]?.results}
                      {...register(`labTests[${index}].results`)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.labTests?.[index]?.results?.message}
                    </Form.Control.Feedback>
                  </td>
                  <td style={{ paddingTop: "10px" }}>
                    <Form.Control
                      type="text"
                      placeholder="Normal Range"
                      isInvalid={!!errors.labTests?.[index]?.normalRange}
                      {...register(`labTests[${index}].normalRange`)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.labTests?.[index]?.normalRange?.message}
                    </Form.Control.Feedback>
                  </td>
                  <td style={{ paddingTop: "10px" }}>
                    <Form.Control
                      type="text"
                      placeholder="Notes"
                      isInvalid={!!errors.labTests?.[index]?.notes}
                      {...register(`labTests[${index}].notes`)}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.labTests?.[index]?.notes?.message}
                    </Form.Control.Feedback>
                  </td>
                  {/* <td
                    style={{
                      paddingTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div {...getRootProps({ className: "py-1" })}>
                      <input {...getInputProps({ multiple: false })} />
                      <Flex justifyContent="center">
                        <FaImage size={27} style={{ cursor: "pointer" }} />
                      </Flex>
                    </div>
                  </td> */}

                  <td
                    style={{
                      paddingTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <input
                      id={`fileInput-${index}`}
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={(e) => {
                        const file = e.target.files?.[0];
                        if (file) {
                          handleDrop([file], index);
                        }
                      }}
                    />
                    <label
                      htmlFor={`fileInput-${index}`}
                      style={{ cursor: "pointer" }}
                    >
                      <Flex justifyContent="center">
                        <FaImage size={27} />
                      </Flex>
                    </label>
                  </td>

                  <td>
                    {uploadedFiles[index]?.preview && (
                      <Flex alignItems="center">
                        <FalconLightBox image={uploadedFiles[index].preview}>
                          <Image
                            rounded
                            width={60}
                            style={{ border: "1px solid #bababa" }}
                            src={uploadedFiles[index].preview}
                            alt={uploadedFiles[index].name}
                          />
                        </FalconLightBox>
                      </Flex>
                    )}
                  </td>
                  <td
                    style={{ paddingLeft: "9px", maxWidth: "10px" }}
                    className="text-center"
                  >
                    <ActionButton
                      icon="trash-alt"
                      title="Delete"
                      variant="danger"
                      className="px-1 py-0"
                      onClick={() => removeLabTests(index)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Row>

      <Row className="gx-2 gy-3 my-1 ">
        <Col className="d-flex justify-content-end">
          <Button
            variant="link"
            className="text-secondary fw-medium p-0 me-3"
            type="button"
            onClick={() => navigate(-1)}
          >
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Ok
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default VisitLabReports;
